import storage from '@/util/storage';
import api from '@/api';
const CACHE_DURATION = 10 * 60 * 1000; // 10分钟缓存有效期

const state = () => {
    const teamDetailsCache = storage.local.get('teamDetailsCache');
    let teamDetails = null;
    if (teamDetailsCache) {
        try {
            const parsed = JSON.parse(teamDetailsCache);
            // 检查缓存是否过期
            if (parsed.timestamp && (Date.now() - parsed.timestamp < CACHE_DURATION)) {
                teamDetails = parsed.data;
            }
        } catch {
            teamDetails = null;
        }
    }
    return {
        userId: storage.local.get('userId') || '',
        platformToken: storage.local.get('platformToken') || '',
        permissions: [],
        realName: storage.local.get('realName') || storage.local.get('login_user') || '',
        userData: storage.local.get('userData') ? JSON.parse(storage.local.get('userData')) : {},
        accountData: storage.local.get('accountData') || null,
        teamDetails,
    };
};

const getters = {
    isLogin: (state) => {
        let retn = false;
        if (state.platformToken) {
            retn = true;
        }
        return retn;
    },
};

const actions = {
    logout ({ commit }) {
        return new Promise((resolve) => {
            commit('removeUserData');
            commit('menu/invalidRoutes', null, { root: true });
            commit('tabbar/clean', null, { root: true });
            commit('menu/removeRoutes', null, { root: true });
            commit('removeAccountData');
            resolve();
        });
    },

    // 获取我的权限
    getPermissions({ commit }) {
        return new Promise((resolve) => {
            api.get('/permission/keys').then((res) => {
                if (res != undefined) {
                    res.data.push('default'); // 默认权限
                    storage.local.set('permissions', JSON.stringify(res.data));
                    commit('setPermissions', { value: res.data });
                    resolve(res);
                }
            });
        });
    },

    // 获取当前用户团队详情（带缓存，避免重复请求）
    getUserRole({ commit, state }) {
        // 如果已缓存，直接返回
        if (state.teamDetails) {
            return Promise.resolve(state.teamDetails);
        }
        return new Promise((resolve) => {
            api.get('/team/details/teamDetailsInfo').then((res) => {
                const data = res.data || {};
                commit('setTeamDetails', data);
                resolve(data);
            }).catch(() => {
                resolve(null);
            });
        });
    },

    // 强制刷新团队详情（忽略缓存）
    refreshUserRole({ commit }) {
        return api.get('/team/details/teamDetailsInfo').then((res) => {
            const data = res.data || {};
            commit('setTeamDetails', data);
            return data;
        });
    },
};

const mutations = {
    setUserData(state, data) {
        const nextUserData = {
            ...(state.userData || {}),
            ...(data || {}),
        };
        const name = nextUserData.userName || nextUserData.realName || '';

        storage.local.set('userData', JSON.stringify(nextUserData));
        storage.local.set('realName', name);
        if (nextUserData.userName) {
            storage.local.set('login_user', nextUserData.userName);
        }
        state.userData = nextUserData;
        state.realName = name;
    },
    setAccountData(state, data) {
        storage.local.set('accountData', data);
        state.accountData = data;
    },
    removeAccountData(state) {
        storage.local.remove('accountData');
        state.accountData = null;
    },
    changeToken(state, token) {
        storage.local.set('platformToken', token);
        state.platformToken = token;
    },

    setToken(state, data) {
        storage.local.set('platformToken', data);
        state.platformToken = data;
    },

    setUserId(state, id) {
        storage.local.set('userId', id);
        state.userId = id;
    },

    setPermissions(state, permissions) {
        state.permissions = permissions.value;
        storage.local.set('permissions', JSON.stringify(permissions.value));
    },

    setTeamDetails(state, details) {
        state.teamDetails = details;
        // 保存时添加时间戳
        storage.local.set('teamDetailsCache', JSON.stringify({
            data: details,
            timestamp: Date.now(),
        }));
    },

    clearTeamDetails(state) {
        state.teamDetails = null;
        storage.local.remove('teamDetailsCache');
    },

    removeUserData(state) {
        storage.local.remove('realName');
        storage.local.remove('platformToken');
        storage.local.remove('login_user');
        storage.local.remove('userId');
        storage.local.remove('permissions');
        storage.local.remove('userData');
        storage.local.remove('accountData');
        storage.local.remove('teamDetailsCache');
        state.platformToken = '';
        state.userId = '';
        state.permissions = [];
        state.realName = '';
        state.userData = {};
        state.accountData = null;
        state.teamDetails = null;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
